import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import ServicesTabs from '../ServicesTabs'
import { SERVICES_TABS } from '../../utils/constants'
import './index.sass'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

const ServicesTypePage = ({ t, match, lng }) => {
  const serviceType = match.params.service.replace('-', '_').toUpperCase()
  if (!serviceType) return null

  return (
    <Fragment>
      <Helmet>
        <html lang={lng} />
        <title>{t(`meta.services.${serviceType}.title`)}</title>
        <link rel="alternate" hrefLang="en"
              href={`https://unimedia.io/services/${serviceType}`} />
          <link rel="alternate" hrefLang="de"
              href={`https://unimedia.io/de/services/${serviceType}`} />
          <link rel="alternate" hrefLang="ru"
              href={`https://unimedia.io/ru/services/${serviceType}`} />
          <link rel="alternate" hrefLang="x-default"
              href={`https://unimedia.io/services/${serviceType}`} />
        <meta name="description" content={t(`meta.services.${serviceType}.descr`)} />
        {lng === 'en' && <meta name="keywords" content={t(`meta.services.${serviceType}.keywords`)} />}
        {lng === 'en' ? <link rel="canonical" href={`https://unimedia.io/services/${match.params.service}`} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/services/${match.params.service}`} />}
        <meta property="og:title" content={t(`meta.services.${serviceType}.title`)} />
        <meta property="og:description" content={t(`meta.services.${serviceType}.descr`)} />
        <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
        <meta property="og:url" content={lng === 'en' ? `https://unimedia.io/services/${serviceType}`: `https://unimedia.io/${lng}/services/${serviceType}`} />
        <script type="application/ld+json">
        {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t(`meta.services.${serviceType}.descr`)}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.services')}",
                "item": "https://unimedia.io/services"
              },{
                "@type": "ListItem",
                "position": 3,
                "name": "${t(`services.${serviceType}`)}"
              }]
            }]`}
          </script>
      </Helmet>
      <ScrollUpButton id={'serviceTypePage'} />
      <div className="services-page container overflow-y" id={'serviceTypePage'}>
        {/* <button onClick={handleBack} className="btn btn-back subtitle-2">
          {t('general.allServices')}
        </button> */}
        <div className="container-wrapper">
        <Breadcrumbs pathname={window.location.pathname} color='white'/>
          <h1 className="main-title">{t(`services.${SERVICES_TABS[serviceType].label}`)}</h1>

          <p className="body-light">{t(`services.descr.${serviceType.toLowerCase()}`)}</p>
          <ServicesTabs serviceType={serviceType} />
        </div>
      </div>
    </Fragment>
  )
}

export default withRouter(translate('translations')(ServicesTypePage))
